<template>
  <div style="width: 100%; height: 100%">

    <div class="top" v-if="false">
      <div>
        <h2>产品列表</h2>
        <div>产品是一组具有相同功能定义的设备集合,创建产品是使用本平台的开始</div>
      </div>
      <div>
        <h3>我的产品</h3>
        <div></div>
      </div>
    </div>
    <!-- 395 -->

    <!-- 395 -->
    <TableBlock
      v-if="isHome"
      ref="tableData"
      :columns="columns"
      :action="action"
      :param="param"
      :topHegiht="260"
      :navHeight="260"
    >
      <div class="common-space-between">
        <div class="common-space-around">
          <!-- <el-button
          type="primary"
          icon="el-icon-plus"
          size="small"
          @click="addBtn"
          >创建产品</el-button
        >
        <el-button
          type="primary"
          icon="el-icon-plus"
          size="small"
          @click="addBtn"
          >创建产品</el-button
        > -->
        
        <!-- margin-left: 10px; -->
        <div v-show="false" style="position: relative;">
          <img src="../../../assets/custom-image/chanpinliebiao_time.png" style="position: absolute;left: 5px;top:5px;width: 22px;height: 22px;z-index: 1;" alt="" srcset="">
          <el-select class="selectC" v-model="dateTime" placeholder="时间排序">
            <el-option
              label="升序"
              value="1">
            </el-option>
            <el-option
              label="降序"
              value="2">
            </el-option>
          </el-select>
        </div>

          <el-input
            v-model="param.keyword"
            :size="this.$store.state.inputSize"
            placeholder="请输入产品ID/产品名称"
            style="margin-right: 10px; width: 260px;"
          >
            <template slot="prepend">产品ID</template>
          </el-input>
          <el-button
          type="primary"
            icon="el-icon-search"
            size="small"
            style="height:32px;margin-left:10px;display: flex;justify-content: center;align-items: center;"     
            :size="this.$store.state.btnSize"
            @click="searchBtn"
            >搜索</el-button
          >
          <el-button
          type="danger"
            icon="el-icon-refresh"
            size="small"
            style="height:32px;margin-left:10px;display: flex;justify-content: center;align-items: center;"     
            @click="resetBtn"
            >重置</el-button
          >
        </div>
        <el-button
          type="primary"
          size="small"
          style="height: 32px;"
          @click="addBtn"
          >
          <div style="display: flex;align-items: center;justify-content: center;position: relative;bottom: 3px;">
            <img style="width: 22px;height: 19px;margin-right: 3px;" src="../../../assets/custom-image/add.png" alt="" srcset="">
            创建分类
          </div>
          </el-button
        >
      </div>
    </TableBlock>
    <Create ref="create" v-if="isJudge.isCreate"></Create>
    <rightAddEdit ref="rightAddEdit"></rightAddEdit>
    <!-- ========================== 子表格 -->
    <children :itemData="itemData" v-if="isJudge.isChildren"></children>
  </div>
</template>
<script>
import rightAddEdit from './module/create/right/right-add-edit.vue'
import children from "./children.vue";
import Create from "./module/create.vue";
import TableBlock from "./module-table/block-table.vue";
import { columns } from "./columns";
import { iotApi } from "@/utils/config";
import { getFun } from '../../../utils/httpFun';
export default {
  name: "index",
  components: {
    TableBlock: TableBlock,
    Create: Create,
    children: children,
    rightAddEdit:rightAddEdit
  },
  data: () => ({
    action: iotApi.SELECTSTANDARPRODUCT,
    columns: [], //表头
    param: {
      //请求参数
      keyword:null,
      factoryId:0
    },
    pid:'',
    isHome:true,
    isJudge:{
      isChildren: false,
      isCreate:false,
    },
    dateTime:'',
    itemData:{},
    isCreateDev:false
  }),
  watch:{
    isJudge:{
      handler(newValue,oldValue){
        console.log('===========测试');
        if(!newValue.isChildren && !newValue.isCreate){
          console.log('=========进入')
          this.isHome = true;
          return;
        }
        if(newValue.isChildren){
          this.isHome = false;
          this.isJudge.isCreate = false;
        }
        if(newValue.isCreate){
          this.isHome = false;
          this.isJudge.isChildren = false;
        }
      },
      deep:true
    }
  },
  created() {
    this.columns = columns(this);
  },
  methods: {
    // 打开继续开发页面
    openExploitPage(item){
      // this.isCreateDev = true;    // 是否创建完设备
      this.itemData = item;
      this.pid = this.itemData.id;
      this.isJudge.isChildren = true;
      this.isJudge.isCreate = false;
      this.isHome = false;
    },
    getPid(){
      // if(this.isCreateDev){
      //   this.isCreateDev = false;
      //   return this.itemData.pId;
      // }else{
        return this.pid;
      // }
    },
    //查询
    searchBtn(ev) {
      
      console.log('查询')
      this.$nextTick((res) => {
        this.$refs.tableData.getDatas();
      });
    },
    //重置第一页
    resetBtn() {
      this.param.keyword = null;
      this.$nextTick((res) => {
        this.$refs.tableData.resetHttp();
      });
    },
    //新增
    addBtn() {
      this.isJudge.isCreate = true;
      this.$nextTick(()=>{
        this.$refs.create.open();
      })
    },
    showOperateBtn(index, item) {
      if (index == 0) {
        this.isJudge.isChildren = true;
        this.itemData = item;
        this.pid = item.pId;
      }else if(index == 1){
        let closeBtn = ()=>{
          console.log('==========成功11')
          this.searchBtn();
        }
        this.$refs.rightAddEdit.open('edit',item,closeBtn);
      }else if(index == 3){
        this.$confirm('是否修改为标准模型?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          getFun(iotApi.SETSTANDARD,{
            pId:item.pId,
            cId:item.cId,
          },res=>{
            if(res.data){
              this.$message.success('修改成功');
              this.$nextTick((res) => {
                this.$refs.tableData.getDatas();
              });
            }else{
              this.$message.warning('修改失败');
            }
          })
        })
      }
    },
    isSetIsChildren(ev){
      this.isJudge.isChildren = ev;
    },
    isSetIsCreate(ev){
      this.isJudge.isCreate = ev;
    }
  },
};
</script>
<style lang="scss" scoped>

.el-input-group__prepend{
  border-radius: 6px;
}
::v-deep .el-input-group--prepend .el-input__inner{
  border-radius: 0 6px 6px 0;

}
::v-deep .el-button{
  border-radius: 6px;
}
// ::v-deep .selectC .el-input__placeholder {
//     color: #ff1616; /* 设置占位文本颜色 */
//     font-size: 14px; /* 设置占位文本字体大小 */
//     /* 添加其他样式 */
//   }
.selectC{
  // margin-left: 10px;
  ::v-deep .el-input__inner {
    padding-left: 30px;
    height: 32px;
    width: 130px;
  }

  ::v-deep .el-input__icon {
    line-height: 27px;
  }
}
::v-deep .el-button--mini {
  padding: 5px 8px;
}
.top{
  padding-left: 15px;
  padding-right: 15px;
  padding-top: 15px;
  padding-bottom: 5px;
  div:nth-child(1){
    div:last-child{
      color: #949AA6;
      font-size: 14px;
    }
  }
  div:nth-child(2){
    h3{
      margin-top: 30px;
      margin-bottom: 8px;
    }
    div:last-child{
      border: 1px solid #ECEEF099;
      position: relative;

      &::after{
        content: '';
        position: absolute;
        left: 0;
        top: -1px;
        display: block;
        clear: both;
        width: 80px;
        height: 3px;
        background: #4990FF;

      }
    }
  }
}
</style>
